import { render, staticRenderFns } from "./page-2.vue?vue&type=template&id=18ab1230&scoped=true&"
import script from "./page-2.vue?vue&type=script&lang=js&"
export * from "./page-2.vue?vue&type=script&lang=js&"
import style0 from "./page-2.vue?vue&type=style&index=0&id=18ab1230&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ab1230",
  null
  
)

export default component.exports